webpackJsonp([1],{

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Game__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Game__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "Game",
    component: __WEBPACK_IMPORTED_MODULE_2_components_Game___default.a
  }]
}));

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(38);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "game",
  data: function data() {
    var currentLetter = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sample("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
    return {
      entries: [{
        city: { name: "Berlin", correct: true, link: "https://www.wikidata.org/wiki/Q64" },
        country: { name: "Belgien", correct: true, link: "https://www.wikidata.org/wiki/Q31" },
        river: { name: "Bröl", correct: true, link: "https://www.wikidata.org/wiki/Q153109" },
        profession: { name: "Bademeister", correct: true, link: "https://www.wikidata.org/wiki/Q2257662" },
        points: 40
      }],
      newEntry: {
        city: "",
        country: "",
        river: "",
        profession: ""
      },
      currentLetter: currentLetter,
      pattern: "^" + currentLetter + ".*",
      loading: false,
      visible: { entity: null, index: null }
    };
  },

  computed: {
    totalPoints: function totalPoints() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sumBy(this.entries, "points");
    }
  },
  methods: {
    check: function check() {
      var self = this;
      this.baseUrl = "https://stadt-land-wikidata.fly.dev/";

      function selectNextLetter() {
        self.currentLetter = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sample("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
        self.pattern = "^[" + self.currentLetter + "].*";
        self.newEntry = {
          city: "",
          country: "",
          river: "",
          profession: ""
        };
        self.loading = false;
      }

      function successHandler(responses) {
        var responsesByEntity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(responses).map("body.data").keyBy("entity").value();

        function pushResults() {
          self.entries.push({
            city: responsesByEntity.city,
            country: responsesByEntity.country,
            river: responsesByEntity.river,
            profession: responsesByEntity.profession,
            points: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sumBy(responses, function (response) {
              return response.body.data.correct ? 1 : 0;
            }) * 10
          });
          selectNextLetter();
        }

        function add(response) {
          responsesByEntity[response.body.data.entity].examples = response.body.data.examples;
        }

        function pushit(exampleResponses) {
          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(exampleResponses, add);
          pushResults();
        }

        var incorrectResponses = responses.filter(function (r) {
          return !r.body.data.correct;
        });

        if (incorrectResponses.length) {
          var examplePromises = incorrectResponses.map(function (response) {
            return self.$http.get("" + self.baseUrl + response.body.data.entity + "_examples?letter=" + self.currentLetter);
          });
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(examplePromises).then(pushit);
        } else {
          pushResults();
        }
      }

      var promises = [this.$http.get(self.baseUrl + "city?name=" + this.newEntry.city), this.$http.get(self.baseUrl + "country?name=" + this.newEntry.country), this.$http.get(self.baseUrl + "river?name=" + this.newEntry.river), this.$http.get(self.baseUrl + "profession?name=" + this.newEntry.profession)];

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(successHandler);
    },
    showExamples: function showExamples(entity, index) {
      var settings = { entity: entity, index: index };
      this.visible = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(this.visible, settings) ? {} : settings;
    }
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)

var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  "data-v-cc56619e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "ui header"
  }, [_vm._v("Stadt, Land, Wikidata!")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/k-nut/stadt-land-wikidata"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
}]}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_c('div', {
    staticClass: "ui padded grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h2', [_vm._v(" Aktueller Buchstabe: "), _c('b', [_vm._v(_vm._s(_vm.currentLetter))])])]), _vm._v(" "), _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.check
    }
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.entries), function(entry, index) {
    return _c('tr', [_vm._l((['city', 'country', 'river', 'profession']), function(entity) {
      return _c('td', [_vm._v("\n              " + _vm._s(entry[entity].name) + "\n              "), (entry[entity].correct) ? _c('a', {
        attrs: {
          "href": entry[entity].link,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "green checkmark icon"
      })]) : _c('div', [_c('i', {
        staticClass: "red close icon"
      }), _vm._v(" "), _c('a', {
        on: {
          "click": function($event) {
            _vm.showExamples(entity, index)
          }
        }
      }, [_vm._v("Beispiel anzeigen")]), _vm._v(" "), _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.visible.entity === entity && _vm.visible.index === index),
          expression: "visible.entity === entity && visible.index === index"
        }]
      }, _vm._l((entry[entity].examples), function(example) {
        return _c('li', [_c('a', {
          attrs: {
            "href": example.item.value,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(example.itemLabel.value))])])
      }))])])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.points))])], 2)
  }), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.city),
      expression: "newEntry.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Stadt",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.country),
      expression: "newEntry.country"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Land",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.river),
      expression: "newEntry.river"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fluss",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.river)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "river", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.profession),
      expression: "newEntry.profession"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Beruf",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "profession", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.totalPoints))])])])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "ui active inverted dimmer"
  }, [_c('div', {
    staticClass: "ui loader"
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Stadt")]), _vm._v(" "), _c('th', [_vm._v("Land")]), _vm._v(" "), _c('th', [_vm._v("Fluss")]), _vm._v(" "), _c('th', [_vm._v("Beruf")]), _vm._v(" "), _c('th', [_vm._v("Punkte")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "ui green labeled icon button",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n                Check\n              ")])])
}]}

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[41]);


// WEBPACK FOOTER //
// static/js/app.daf3dc4469ed1c1bdba1.js